// /pages/carrossier/FormulaireB/components/SectionControles.js
import React from "react";
import RadioGroup from "./shared/RadioGroup";

const SectionControles = ({ formData, handleControleChange, productId }) => {
  return (
    <>
      {/* Section 5 : Contrôles tablier HUSKY */}
      <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
          <span className="text-xl">🔧</span>
          5. Contrôles tablier - Configuration HUSKY
        </h3>
        
        <div className="bg-green-50 p-4 rounded-xl mb-6 border border-green-200">
          <div className="grid grid-cols-4 gap-4 font-semibold text-sm text-green-800">
            <span>Élément à contrôler</span>
            <span className="text-center">O (Oui)</span>
            <span className="text-center">So (Sans objet)</span>
            <span className="text-center">N (Non)</span>
          </div>
        </div>
        
        <div className="space-y-1">
          {[
            ["A", "Calage des roulettes"],
            ["B", "Roulettes FIT Max (Verte)"],
            ["C", "Bras haut roulettes FIT X-Trem (Bleu)"],
            ["D", "Roulettes Fit X-Trem (bleu)"],
            ["E", "Ressort de calage pour roulette Fit X-trem (bleu)"],
            ["F", "Réglage des excentriques"],
            ["G", "Serrage des vis des écrous"],
            ["H", "Axes des charnières"],
            ["I", "Joints latéraux"],
            ["J", "Finition brute"],
            ["K", "Finition peinture"],
            ["L", "Plaque de firme avec QR-Code instruction (face extérieure de la porte)"],
            ["M", "Sticker sécurité section basse"],
            ["O", "Plaque CE sur section haute côté intérieur"],
          ].map(([code, label]) => 
            <RadioGroup
              key={`tablier-${code}`}
              controle="tablier"
              field={code}
              label={`${code} - ${label}`}
              formData={formData}
              handleControleChange={handleControleChange}
              productId={productId}
              color="green"
            />
          )}
        </div>
      </section>

      {/* Section 6 : Contrôles rails HUSKY */}
      <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
          <span className="text-xl">🛤️</span>
          6. Contrôles rails
        </h3>
        
        <div className="space-y-1 mb-6">
          {[
            ["A", "Jonction rails horizontaux/verticaux (continue)"],
            ["B", "Fixation rails verticaux"],
            ["C", "Fixation rails horizontaux"],
            ["D", "Côte entre le rail horizontal chauffeur et le pavillon"],
            ["E", "Côte entre le rail horizontal passager et le pavillon"],
            ["F", "Parallélisme rails verticaux/horizontaux"],
            ["G", "Jeu constant porte/rails"]
          ].map(([code, label]) => 
            <RadioGroup
              key={`rails-${code}`}
              controle="rails"
              field={code}
              label={`${code} - ${label}`}
              formData={formData}
              handleControleChange={handleControleChange}
              productId={productId}
              color="green"
            />
          )}
        </div>

        {/* Côtes et mesures pour HUSKY */}
        <div className="bg-blue-50 p-4 rounded-xl">
          <h4 className="font-semibold text-gray-900 mb-4">Mesures en mm</h4>
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">D - Côté chauffeur - Relevé en mm</label>
              <input
                type="number"
                placeholder="Mesure en mm"
                value={formData.controles.railsDetailles?.coteRailHorizontalChauffeur || ""}
                onChange={(e) => handleControleChange("railsDetailles", "coteRailHorizontalChauffeur", e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">E - Côté passager - Relevé en mm</label>
              <input
                type="number"
                placeholder="Mesure en mm"
                value={formData.controles.railsDetailles?.coteRailHorizontalPassager || ""}
                onChange={(e) => handleControleChange("railsDetailles", "coteRailHorizontalPassager", e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 7 : Ressorts HUSKY */}
      <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
          <span className="text-xl">⚙️</span>
          7. Ressorts
        </h3>
        
        <div className="space-y-1 mb-6">
          {[
            ["A", "Attaches câbles"],
            ["B", "Goupilles attaches câbles"],
            ["C", "Goupilles arbre ressort"],
            ["D", "Serrage pièces d'immobilisation"],
            ["E", "Serrage support central"],
            ["F", "Position des câbles"]
          ].map(([code, label]) => 
            <RadioGroup
              key={`ressorts-${code}`}
              controle="ressorts"
              field={code}
              label={`${code} - ${label}`}
              formData={formData}
              handleControleChange={handleControleChange}
              productId={productId}
              color="green"
            />
          )}
        </div>

        {/* Tension avec nombre de tours */}
        <div className="bg-green-50 p-4 rounded-xl">
          <h4 className="font-semibold text-gray-900 mb-4">G - Tension</h4>
          <div className="grid grid-cols-2 gap-6">
            <div className="grid grid-cols-4 items-center gap-4">
              <span className="text-sm font-medium text-gray-900">Tension correcte</span>
              {["O", "So", "N"].map((opt) => (
                <label key={opt} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name={`tension_${productId || 'default'}`}
                    value={opt}
                    checked={formData.controles.ressorts?.tension === opt}
                    onChange={() => handleControleChange("ressorts", "tension", opt)}
                    className="text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">{opt}</span>
                </label>
              ))}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nombre de tours</label>
              <input
                type="number"
                placeholder="Nombre de tours"
                value={formData.controles.ressorts?.nombreTours || ""}
                onChange={(e) => handleControleChange("ressorts", "nombreTours", e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section 8 : Caisse / Cadre arrière HUSKY */}
      <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
        <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
          <span className="text-xl">🏗️</span>
          8. Caisse / Cadre arrière
        </h3>
        
        <div className="space-y-6">
          {/* Contrôles de base */}
          <div className="space-y-1">
            {[
              ["A", "Équerrage cadre arrière"],
              ["B", "Parallélisme"],
              ["C", "Parois latérales"]
            ].map(([code, label]) => 
              <RadioGroup
                key={`cadreArriere-${code}`}
                controle="cadreArriere"
                field={code}
                label={`${code} - ${label}`}
                formData={formData}
                handleControleChange={handleControleChange}
                productId={productId}
                color="green"
              />
            )}
          </div>

          {/* Parodies latérales détaillées */}
          <div className="bg-purple-50 p-4 rounded-xl">
            <h4 className="font-semibold text-gray-900 mb-4">Détails parodies latérales</h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.controles.cadreArriereDetaille?.parodiesLateralesBois === "true"}
                    onChange={(e) => handleControleChange("cadreArriereDetaille", "parodiesLateralesBois", e.target.checked ? "true" : "")}
                    className="text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Bois</span>
                </label>
              </div>
              <div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.controles.cadreArriereDetaille?.parodiesLateralesIsolees === "true"}
                    onChange={(e) => handleControleChange("cadreArriereDetaille", "parodiesLateralesIsolees", e.target.checked ? "true" : "")}
                    className="text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Isolées</span>
                </label>
              </div>
            </div>
          </div>

          {/* Type de pavillon */}
          <div className="bg-indigo-50 p-4 rounded-xl">
            <h4 className="font-semibold text-gray-900 mb-4">D - Type de pavillon</h4>
            <div className="grid grid-cols-4 items-center gap-4 mb-4">
              <span className="text-sm font-medium text-gray-900">Type de pavillon</span>
              {["O", "So", "N"].map((opt) => (
                <label key={opt} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name={`pavillon_${productId || 'default'}`}
                    value={opt}
                    checked={formData.controles.cadreArriere?.typePavillon === opt}
                    onChange={() => handleControleChange("cadreArriere", "typePavillon", opt)}
                    className="text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">{opt}</span>
                </label>
              ))}
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.controles.cadreArriereDetaille?.pavillonTranslucide === "true"}
                    onChange={(e) => handleControleChange("cadreArriereDetaille", "pavillonTranslucide", e.target.checked ? "true" : "")}
                    className="text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Translucide</span>
                </label>
              </div>
              <div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.controles.cadreArriereDetaille?.pavillonIsole === "true"}
                    onChange={(e) => handleControleChange("cadreArriereDetaille", "pavillonIsole", e.target.checked ? "true" : "")}
                    className="text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Isolé</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionControles;